export default "__VITE_ASSET__Csl1zv0i__"